
import { IOrganizationCatalog } from "src/app/models/organization-catalog.model";
import { ReduxWrapper } from "../app.state";
import { UserProduct } from "src/app/models/user-products.model";

export class OrganizationCatalogState {
	info!: ReduxWrapper<IOrganizationCatalog | undefined>
	templates!: ReduxWrapper<UserProduct[]>
	// theme!: ReduxWrapper<CatalogProduct[]>
	// webpart!: ReduxWrapper<CatalogProduct[]>
	// accessibility!: ReduxWrapper<CatalogProduct[]>
}

export const productTypeDefaultValue: ReduxWrapper<UserProduct[]> = {
	error: undefined,
	loadedOnce: false,
	loading: false,
	value:[]
};

export const orgInfoDefaultValue: ReduxWrapper<IOrganizationCatalog | undefined> = {
	error: undefined,
	loadedOnce: false,
	loading: false,
	value: undefined
};

export const organizationCatalogInitialState: OrganizationCatalogState = {
	info: orgInfoDefaultValue,
	templates: productTypeDefaultValue
};
